// extracted by mini-css-extract-plugin
export default {"headerTitle":"ChatClientPage_headerTitle__tKZgS","headerBackButton":"ChatClientPage_headerBackButton__d1Mqf","headerRightButton":"ChatClientPage_headerRightButton__JlUeV"};